import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isLoginPage = location?.pathname === '/login';
  const isRegisterPage = location?.pathname === '/register';

  if (!isLoginPage && !isRegisterPage) {
    return null;
  }

  return (
    <div className="text-center mt-24">
      <p className="text-sm text-muted-foreground font-caption">
        {isLoginPage ? "Don't have an account? " : "Already have an account? "}
        <button
          onClick={() => navigate(isLoginPage ? '/register' : '/login')}
          className="text-primary font-medium hover:text-accent transition-smooth hover:underline min-h-[44px] inline-flex items-center px-8"
        >
          {isLoginPage ? 'Sign up' : 'Sign in'}
        </button>
      </p>
      {isLoginPage && (
        <button
          onClick={() => console.log('Forgot password clicked')}
          className="text-sm text-muted-foreground hover:text-primary transition-smooth hover:underline mt-12 min-h-[44px] inline-flex items-center px-8"
        >
          Forgot your password?
        </button>
      )}
    </div>
  );
};

export default AuthNavigation;